/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable jsx-a11y/anchor-is-valid */
import '@fontsource/poppins';
import { Icon } from '@iconify/react';
import axios from 'axios';
// eslint-disable-next-line import/no-extraneous-dependencies
import beginner from 'src/assets/images/beginner.png';
import image from 'src/assets/images/rectangle.png';

import {
  Avatar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import React, { useState } from 'react';

import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import AddAchievement from '@src/components/modals/addAchievement';
import AddResume from '@src/components/modals/addResume';
import AddVaccinationCert from '@src/components/modals/addVaccinationCert';
import { useAuth } from '@src/contexts/authContext';

import { openLinkInPopUpWindow } from '@utils';

const url = `${process.env.REACT_APP_API_URL}`;

export default function CLAProfile({ handleAchievement }) {
  const { auth } = useAuth();
  const { userId } = useParams();

  const handleOpenSlide = (file) => async () => openLinkInPopUpWindow(file);

  const [getProfile, setGetProfile] = useState();
  React.useEffect(() => {
    if (auth?.idToken) {
      axios
        .get(`${url}/admin/users/${userId}`, {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
          },
        })
        .then((response) => {
          setGetProfile(response.data);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, userId]);

  const [getResume, setGetResume] = useState([]);

  const fetchDataResume = () => {
    if (auth?.idToken) {
      axios
        .get(`${url}/resume/${userId}`, {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
          },
        })
        .then((response) => {
          setGetResume(response.data);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const [deleteStatus, setDeleteStatus] = useState();
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);

  const [getAchievement, setGetAchievement] = useState([]);

  const fetchData = () => {
    if (auth?.idToken) {
      axios
        .get(`${url}/admin/achievements/${userId}`, {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
          },
        })
        .then((response) => {
          setGetAchievement(response.data);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const handleDeleteAchievement = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/admin/achievements/${id}`,
        {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
            'My-Custom-Header': 'foobar',
          },
        },
      );

      if (response.status === 200) {
        console.log(response);
        setDeleteStatus('Delete successful');
        setShowDeleteSuccess(true);
        toast.success('Item deleted successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
      } else {
        console.error('Delete operation failed');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const showDeleteConfirmationDialog = (id) => {
    setDeleteId(id);
    setShowDeleteConfirmation(true);
  };

  const handleConfirmationDialogClose = () => {
    setShowDeleteConfirmation(false);
  };

  const handleConfirmationDialogConfirm = () => {
    handleDeleteAchievement(deleteId);
    setShowDeleteConfirmation(false);
  };

  const [getVaccine, setGetVaccine] = useState([]);

  const fetchDataVaccine = () => {
    if (auth?.idToken) {
      axios
        .get(`${url}/vaccination/${userId}`, {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
          },
        })
        .then((response) => {
          setGetVaccine(response.data);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const extractFileName = (urls) => {
    try {
      const parsedUrl = new URL(urls);
      const pathSegments = parsedUrl.pathname.split('/');
      const fileName = pathSegments[pathSegments.length - 1];
      // const shortFileName = fileName.slice(-10);
      return fileName || 'No file chosen';
    } catch (error) {
      console.error(urls);
      return '';
    }
  };

  const [openModal, setOpenModal] = useState(false);
  const showModal = () => {
    setOpenModal(true);
  };

  const [openModals, setOpenModals] = useState(false);
  const showModals = () => {
    setOpenModals(true);
  };

  const [openModalResume, setOpenModalResume] = useState(false);
  const showModalResume = () => {
    setOpenModalResume(true);
  };

  const [deletedStatus, setDeletedStatus] = useState();
  const [deletedId, setDeletedId] = useState(null);
  const [showDeleteConfirmations, setShowDeleteConfirmations] = useState(false);
  const [showDeletedSuccess, setShowDeletedSuccess] = useState(false);

  const handleDeleteVaccine = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/admin/vaccinations/${id}`,
        {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
            'My-Custom-Header': 'foobar',
          },
        },
      );

      if (response.status === 200) {
        console.log(response);
        setDeletedStatus('Delete successful');
        setShowDeletedSuccess(true);
        toast.success('Item deleted successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
      } else {
        console.error('Delete operation failed');
      }
    } catch (error) {
      console.error(error);
      toast.error(`${error.response.data.message}`, {
        position: 'top-center',
        autoClose: 2000,
      });
    }
  };

  const showDeletedConfirmationDialog = (id) => {
    setDeletedId(id);
    setShowDeleteConfirmations(true);
  };

  const handleConfirmationsDialogClose = () => {
    setShowDeleteConfirmations(false);
  };

  const handleConfirmationsDialogConfirm = () => {
    handleDeleteVaccine(deletedId);
    setShowDeleteConfirmations(false);
  };

  React.useEffect(() => {
    fetchData();
    fetchDataResume();
    fetchDataVaccine();
  }, [auth, deleteStatus, deletedStatus]);

  const [badge, setBadge] = React.useState();

  React.useEffect(() => {
    if (auth.idToken) {
      axios
        .get(`${url}/admin/v3/users/${userId}/badges`, {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
          },
        })
        .then((response) => {
          setBadge(response.data.response.data);
        })
        .catch((error) => {
          console.log(error.message);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  return (
    <Box sx={{ width: '100%', fontFamily: 'Poppins' }} className='w-[90%]'>
      <div className='grid grid-cols-2'>
        <div className='col-end-2'>
          <Box
            className='rounded-xl'
            sx={{
              height: 'auto',
              width: 'auto',
              backgroundColor: 'white',
              margin: 2,
            }}
          >
            <div className='flex px-6 py-6'>
              <Box>
                <img
                  src={
                    getProfile?.profile_pict ? getProfile?.profile_pict : image
                  }
                  alt=''
                  className='h-20 w-20 rounded-full border-2 border-cyan-500 shadow'
                />
                <Box display={'flex'} justifyContent='end'>
                  {badge?.show_locum_badge_level && (
                    <Avatar
                      sx={{ mt: -3.5 }}
                      src={badge?.locum_badge_image_link || beginner}
                    />
                  )}
                </Box>
              </Box>
              <div className='px-5 leading-3'>
                <p className='text-[16px] font-semibold text-cyan-700'>
                  {getProfile?.full_name || 'No name added'}
                </p>
                <p className='text-[14px] text-gray-500'>
                  {getProfile?.email || 'No email added'}
                </p>
                <p className='text-[14px] text-gray-500'>
                  {getProfile?.phone_number || 'No number added'}
                </p>
              </div>
            </div>
            <div className='flex gap-x-3 px-6'>
              <p className='rounded-full bg-blue-50 px-3 py-1 text-cyan-600'>
                <div className='font-bold'>
                  {getProfile?.mcr || 'No MCR added'}
                </div>
              </p>
              <p className='rounded-full bg-blue-50 px-3 py-1 text-cyan-600'>
                <div className='font-bold'> {getProfile?.role_id}</div>
              </p>
            </div>
            <br />
          </Box>
          <Box
            className='rounded-xl'
            sx={{
              height: 'auto',
              width: 'auto',
              backgroundColor: 'white',
              margin: 2,
            }}
          >
            <div className='font-poppins px-6 py-6 font-bold'>ABOUT</div>
            <div className='px-6 text-gray-500'>
              {getProfile?.about_me
                ? getProfile?.about_me.split('\n').map((paragraph, index) => (
                    <p
                      // eslint-disable-next-line react/no-array-index-key
                      key={index}
                      style={{ textAlign: 'justify' }}
                    >
                      {paragraph}{' '}
                    </p>
                  ))
                : 'No about added'}
            </div>
            <br />
          </Box>
          <Box
            className='rounded-xl'
            sx={{
              height: 'auto',
              width: 'auto',
              backgroundColor: 'white',
              margin: 2,
            }}
          >
            <div className='font-poppins px-6 py-6 font-bold'>PREFERENCES</div>
            <div className='text-gray-500'>
              {getProfile?.preferences && getProfile.preferences.length > 0 ? (
                getProfile.preferences.map((preference) => (
                  <div className='flex px-4'>
                    <Icon
                      icon='fluent:checkbox-checked-20-filled'
                      color='#4ed39c'
                      width='30'
                      height='30'
                    />
                    <div className='px-2 py-1'>{preference}</div>
                  </div>
                ))
              ) : (
                <div className='px-6'>No preference added</div>
              )}
            </div>

            <br />
          </Box>
          <Box
            className='rounded-xl'
            sx={{
              height: 'auto',
              width: 'auto',
              backgroundColor: 'white',
              margin: 2,
            }}
          >
            <div className='font-poppins px-6 py-6 font-bold'>REFERRAL</div>
            <div className='flex justify-start px-6'>
              <div className='text-sm text-gray-600'>Referral code:</div>
              <div className='px-8 text-gray-500'>
                {getProfile?.referal_code || 'no referral'}
              </div>
            </div>
            <div className='flex justify-start px-6 py-2'>
              <div className='text-sm text-gray-600'>Referred by:</div>
              <div className='px-12 text-gray-500'>
                {getProfile?.refered_by_name || '-'}
              </div>
            </div>

            <br />
          </Box>
        </div>
        <div className='col-auto'>
          <Box
            className='rounded-xl'
            sx={{
              height: 'auto',
              width: 'auto',
              backgroundColor: 'white',
              margin: 2,
            }}
          >
            <div className='flex justify-between'>
              <div className='font-poppins px-6 py-6 font-bold'>RESUME</div>
              <Button
                sx={{
                  textTransform: 'none',
                  width: '150px',
                  backgroundColor: 'white',
                }}
                className='px-6 text-xs font-bold text-cyan-600 underline'
                variant='text'
                onClick={showModalResume}
              >
                Edit resume
              </Button>
            </div>

            <span>
              <div className=' text-gray-500'>
                {getResume && getResume.length > 0 ? (
                  getResume.map((files) => (
                    <div className='flex justify-between px-4' key={files.file}>
                      <div className='px-2 py-2'>
                        {extractFileName(files.file)}
                      </div>
                      <div className='px-12 py-2'>
                        <Icon
                          icon='carbon:view-filled'
                          onClick={handleOpenSlide(files?.file)}
                          color='#1788b9'
                          width='28'
                        />
                        &nbsp; &nbsp;
                        {/* <Icon
                          onClick={() =>
                            showDeleteConfirmationDialog(cert?._id)
                          }
                          icon='clarity:remove-solid'
                          color='#FF5555'
                          width='28'
                          className='h-6 w-6 scale-100 transform rounded-full py-0.5 px-2 transition-transform group-hover:scale-110'
                        /> */}
                      </div>
                      {showDeleteConfirmation && (
                        <Dialog
                          open={showDeleteConfirmation}
                          onClose={handleConfirmationDialogClose}
                        >
                          <DialogTitle>Confirm Delete</DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              Are you sure you want to delete this item?
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={handleConfirmationDialogClose}
                              color='primary'
                            >
                              Cancel
                            </Button>
                            <Button
                              onClick={handleConfirmationDialogConfirm}
                              color='error'
                            >
                              Delete
                            </Button>
                          </DialogActions>
                        </Dialog>
                      )}
                    </div>
                  ))
                ) : (
                  <div className='px-6'>No resume added</div>
                )}
              </div>
            </span>
            <br />
          </Box>

          <Box
            className='rounded-xl'
            sx={{
              height: 'auto',
              width: 'auto',
              backgroundColor: 'white',
              margin: 2,
            }}
          >
            <div className='flex justify-between'>
              <div className='font-poppins px-6 py-6 font-bold'>
                ACHIEVEMENTS
              </div>
              <div className='py-6 px-8'>
                <Button
                  variant='text'
                  className='justify-left flex text-xs font-bold text-cyan-600 underline'
                  sx={{ textTransform: 'none', padding: 0 }}
                  onClick={showModal}
                >
                  Add new
                </Button>
              </div>
            </div>

            <span>
              <div className=' text-gray-500'>
                {getAchievement && getAchievement.length > 0 ? (
                  getAchievement.map((cert) => (
                    <div className='flex justify-between px-4' key={cert.item}>
                      <div className='px-2 py-1'> {cert.item}</div>

                      <div className='px-2 py-1'>
                        <Icon
                          icon='carbon:view-filled'
                          onClick={handleOpenSlide(cert?.file)}
                          color='#1788b9'
                          width='28'
                        />
                        &nbsp; &nbsp;
                        <Icon
                          onClick={() =>
                            showDeleteConfirmationDialog(cert?._id)
                          }
                          icon='clarity:remove-solid'
                          color='#FF5555'
                          width='23'
                        />
                      </div>
                      {showDeleteConfirmation && (
                        <Dialog
                          open={showDeleteConfirmation}
                          onClose={handleConfirmationDialogClose}
                        >
                          <DialogTitle>Confirm Delete</DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              Are you sure you want to delete this item?
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={handleConfirmationDialogClose}
                              color='primary'
                            >
                              Cancel
                            </Button>
                            <Button
                              onClick={handleConfirmationDialogConfirm}
                              color='error'
                            >
                              Delete
                            </Button>
                          </DialogActions>
                        </Dialog>
                      )}
                    </div>
                  ))
                ) : (
                  <div className='px-6'>No data added</div>
                )}
              </div>
            </span>

            <br />
          </Box>

          <Box
            className='rounded-xl'
            sx={{
              height: 'auto',
              width: 'auto',
              backgroundColor: 'white',
              margin: 2,
            }}
          >
            <div className='flex justify-between'>
              <div className='font-poppins px-6 py-6 font-bold'>
                VACCINATION CERTIFICATES
              </div>
              <Button
                sx={{
                  textTransform: 'none',
                  width: '130px',
                  backgroundColor: 'white',
                }}
                className='px-6 text-xs font-bold text-cyan-600 underline'
                variant='text'
                onClick={showModals}
              >
                Add new
              </Button>
            </div>

            <span>
              <div className=' text-gray-500'>
                {getVaccine && getVaccine.length > 0 ? (
                  getVaccine.map((cert) => (
                    <div className='flex justify-between px-4' key={cert.item}>
                      <div className='px-2 py-1'> {cert.item}</div>

                      <div className='px-2 py-1'>
                        <Icon
                          icon='carbon:view-filled'
                          onClick={handleOpenSlide(cert?.file)}
                          color='#1788b9'
                          width='28'
                        />
                        &nbsp; &nbsp;
                        <Icon
                          onClick={() =>
                            showDeletedConfirmationDialog(cert?._id)
                          }
                          icon='clarity:remove-solid'
                          color='#FF5555'
                          width='23'
                        />
                      </div>
                      {showDeleteConfirmations && (
                        <Dialog
                          open={showDeleteConfirmations}
                          onClose={handleConfirmationsDialogClose}
                        >
                          <DialogTitle>Confirm Delete</DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              Are you sure you want to delete this item?
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={handleConfirmationsDialogClose}
                              color='primary'
                            >
                              Cancel
                            </Button>
                            <Button
                              onClick={handleConfirmationsDialogConfirm}
                              color='error'
                            >
                              Delete
                            </Button>
                          </DialogActions>
                        </Dialog>
                      )}
                    </div>
                  ))
                ) : (
                  <div className='px-6'>No certificate added</div>
                )}
              </div>
            </span>
            <br />
          </Box>
        </div>
      </div>

      <AddAchievement
        handleAchievement={handleAchievement}
        setOpenModal={setOpenModal}
        showModal={showModal}
        openModal={openModal}
        fetchData={fetchData}
      />

      <AddVaccinationCert
        showModals={showModals}
        openModals={openModals}
        fetchDataVaccine={fetchDataVaccine}
        setOpenModals={setOpenModals}
      />

      <AddResume
        showModalResume={showModalResume}
        openModalResume={openModalResume}
        fetchDataResume={fetchDataResume}
        setOpenModalResume={setOpenModalResume}
      />
    </Box>
  );
}
